import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Progress, theme } from "antd";
import { COLOR_ERROR_SOFT } from "../../../../../../style/antdTheme.js";
import { __ } from "../../../../../../utils/i18n.js";
// `used` counts seats allocated across license keys, not active installs —
// the per-key install list lives in the activations sub-table.
const SubscriptionLicenseAllocationCapacityBar = ({ used, total, label })=>{
    const { token } = theme.useToken();
    const percent = total > 0 ? used / total * 100 : 0;
    const isFull = total > 0 && used >= total;
    const color = isFull ? COLOR_ERROR_SOFT : token.colorPrimary;
    return /*#__PURE__*/ _jsxs("div", {
        className: "rc-account-v2-subscription-card__capacity",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-subscription-card__capacity-row",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "rc-account-v2-subscription-card__capacity-label",
                        style: {
                            color: token.colorText
                        },
                        children: label
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "rc-account-v2-subscription-card__capacity-value",
                        style: {
                            color: isFull ? COLOR_ERROR_SOFT : token.colorTextHeading,
                            fontVariantNumeric: "tabular-nums"
                        },
                        children: __("%s of %s allocated", used, total)
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Progress, {
                percent: percent,
                strokeColor: color,
                strokeWidth: 6,
                showInfo: false
            })
        ]
    });
};
export { SubscriptionLicenseAllocationCapacityBar };
